import { CwtModel, CwtProp } from "@cawita/core-front/api";
import { EvaluationResultEntity } from "./eval-result.entity";
import { QuestionAnswer } from "./question-eval.model";

@CwtModel({ name: 'eval-emotional' })
export class EvalEmotional extends EvaluationResultEntity {
    @CwtProp() answerScore: number;
    @CwtProp() selfRegulationDifficultiesAnswerScore: number;
    @CwtProp() performanceConcernsAnswerScore: number;
    @CwtProp() externalisedCopingAnswerScore: number;
    @CwtProp() vass: number;
    @CwtProp() distressFactors: string[];
    @CwtProp({ ref: QuestionAnswer }) result: QuestionAnswer[];
}